import React from "react"
import { Link } from "gatsby"
import { useMediaQuery } from "react-responsive"
import Img from "gatsby-image"
import camelcase from "lodash.camelcase"

import styles from "../../styles/home-hero.module.scss"

const HomeHero = props => {
  return (
    <div className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <h1 className={styles.copy}>{props.copy}</h1>
          <p className={styles.subtext}>{props.subtext}</p>
          <div className={styles.buttonContainer}>
            <Link className={styles.left} to={props.buttons.mainButton.url}>
              {props.buttons.mainButton.title.toUpperCase()}
            </Link>
            <Link
              className={styles.right}
              to={props.buttons.secondaryButton.url}
            >
              {props.buttons.secondaryButton.title.toUpperCase()}
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.featureSection}>
        <div className={styles.featureBox}>
          <div className={styles.featureIcon}>
            <img
              width="24"
              height="25"
              src={"/images/home-features-icon.png"}
              alt="home features icon"
              loading="eager"
            />
          </div>
          <div className={styles.featureHeading}>
            <h2>{props.featureBox.copy}</h2>
            <p>{props.featureBox.subtext}</p>
          </div>
          <div className={styles.featureContainer}>
            {props.featureBox.features.map((feature, index) => (
              <div key={index} className={styles.feature}>
                <div className={styles.iconContainer}>
                  <Img
                    fixed={feature.icon.imageFile.childImageSharp.fixed}
                    alt={feature.icon.altText}
                    loading="eager"
                    fadeIn={false}
                  />
                </div>
                <div className={styles.contentContainer}>
                  <h2>{feature.title}</h2>
                  <p>{feature.subtext}</p>
                </div>
                <Link className={styles.featureButton} to={feature.button.url}>
                  {feature.button.title}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeHero
